module.exports = __webpack_public_path__ + "img/icomoon.cc0e2ae.svg";